import { useListOrganizations } from '@/queries/organizations.queries';
import { useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export function useTeamsPage() {
	const modalDisclosure = useDisclosure();
	const query = useListOrganizations();
	const { t } = useTranslation();

	return {
		modalDisclosure,
		query,
		t,
	};
}
